import { User } from '@/types/user';

export function isLivenessVerified(user?: User | null): boolean {
  if (!user) return false;
  return !!user.is_liveness_verified;
}
